import React from 'react';
import AuthWrapper from '../components/molecules/AuthWrapper';
import ChapterTemplate from '../components/templates/Chapter';

const Chapter = () => {
  return <AuthWrapper renderProps={ChapterTemplate} />;
};

export default Chapter;
